<template>
  <div :class="{ 'input-container': true, wide: wide }">
    <input
      ref="numeric_input"
      id="input"
      :key="refresh_key"
      :value="value"
      :disabled="disabled"
      :class="{ wide: wide }"
      @blur="blur"
      @focus="focus"
      :type="number ? 'number' : 'text'"
    />
    <span :class="{ disabled: disabled, wide: wide }">m<sup>2</sup></span>
  </div>
</template>

<style lang="scss" scoped>
.input-container {
  position: relative;
  height: 100%;
  width: 100%;
}

input {
  border: none;
  border-radius: 1.75rem;
  height: 100%;
  width: 100%;
  outline: none;
  padding-right: 3.2rem;
  text-align: right;
  -webkit-appearance: none;
  -moz-appearance: textfield;
  appearance: none;

  &.wide {
    border-radius: 4.4rem;
    font-size: 2.1rem;
    padding-right: 4rem;
  }
}

span {
  position: absolute;
  display: flex;
  align-items: center;
  right: 0;
  width: 2.8rem;
  height: 100%;
  top: 0.1em;
  z-index: 1;
  font-size: 0.8em;

  &.wide {
    font-size: 2.1rem;
    width: 3.4rem;
    top: 0;
  }
}
</style>

<script>
export default {
  name: "vue-input",
  props: {
    name: String,
    value: { type: [String, Number] },
    length: { type: Number, default: 3 },
    min_value: { type: Number, default: 0 },
    max_value: { type: Number, default: 999 },
    number: { type: Boolean, default: true },
    disabled: { type: Boolean, default: false },
    wide: { type: Boolean, default: false },
    pre_approve: Function,
  },
  data: function () {
    return {
      start_value: 0,
      refresh_key: 1,
    };
  },
  methods: {
    focus: function () {
      this.start_value = +this.value;
    },
    blur: async function (ev) {
      let coarced = "";
      let textValue = ev.target.value;

      let final = "";
      for (let index = 0; index < textValue.length; index++) {
        if ("0123456789.".indexOf(textValue.substr(index, 1)) !== -1) {
          final += textValue.substr(index, 1);
        }
      }
      let value = +final;
      value = isNaN(value) ? 0 : value;

      if (value < this.min_value) {
        value = this.min_value;
        coarced = "min";
      }

      if (value > this.max_value) {
        value = this.max_value;
        coarced = "max";
      }

      if (value === this.start_value) {
        this.refresh_key = 1 - this.refresh_key;
        return;
      }

      if (this.pre_approve) {
        let res = await this.pre_approve(this.name, value, coarced);
        if (!res) {
          this.refresh_key = 1 - this.refresh_key;
          return;
        }
      }

      this.$emit("vue-input-change", { name: this.name, value: Math.round(value), approved: true });
      if (coarced) {
        this.$emit("vue-input-coarce", coarced);
      }
    },
  },
};
</script>
